import type { SVGProps } from 'react';

export function HashIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1={2.67} x2={13.33} y1={6} y2={6} />
      <line x1={2.67} x2={13.33} y1={10} y2={10} />
      <line x1={6.67} x2={5.33} y1={2} y2={14} />
      <line x1={10.67} x2={9.33} y1={2} y2={14} />
    </svg>
  );
}
